// Dependencias generales
import React from "react";
import { useEffect, useState } from 'react';
import InitialConfigHeader from '../../../components/InitialConfig/UserInitialConfigHeader'
import StepIntro from '../../../components/InitialConfig/StepIntro'
import AsideMenu from '../../../components/InitialConfig/AsideMenu'
import AppLogoImg from '../../../components/Utils/AppLogoImg'
import Loader from '../../../components/Utils/Loader'
import WorkflowNavigationButtons from '../../../components/InitialConfig/WorkflowNavigationButtons';
import WorkflowIlustration from "../../../components/InitialConfig/WorkflowIlustration";
import FormValidationError from "../../../components/InitialConfig/FormValidationError";
import ReactGA from "react-ga4";

const endpointHelias = "https://9m4y8iz04h.execute-api.eu-west-3.amazonaws.com/prod"
const updateInstallationConfiguration = endpointHelias+"/Helias/V0/Configuration/updateInstallationConfiguration"
const getInstallationConfiguration = endpointHelias+"/Helias/V0/Configuration/getInstallationConfiguration"

var initialConfigCommonJS = require("../../../js/initialConfigCommon.js");
var generalCommonJS = require("../../../js/generalCommon.js")

// Initial config - Generator
const Generator = () => {

  const [selectedLocation, setSelectedLocation] = useState([{ id: "", distance: "", lat: "40.4167754", long: "-3.7037902" }]) //Default Madrid

  useEffect(() => {    

    if(initialConfigCommonJS.antiBackOnboarding() === false){      
      
      if(localStorage.getItem("installationConfigurationMode") === null){
        localStorage.removeItem("currentInstallationConfiguration")
        localStorage.removeItem("configuredApps")
        generalCommonJS.registrarEventoAnalitica(ReactGA, 'REGISTRO', 'REGISTRO - GRUPO ELECTRÓGENO', "", "")
      }
      
      initialConfigCommonJS.actualizarPasoWorkflowEnBBDD("GENERATOR")

      document.getElementById("divFases2y3").style = "display: none"

      mostrarPestañaTipoGrupo("MONOFASICO")
      
      if(localStorage.getItem("currentInstallationConfiguration") !== null){        
        procesarConfiguracionActual(JSON.parse(localStorage.getItem("currentInstallationConfiguration")))
      }
      else{
        cargarConfiguracionActualPaso()        
      }

      if(localStorage.getItem("installationConfigurationMode") !== null){
        document.getElementById("generator").className = "step"
        initialConfigCommonJS.visibilidadModoConfiguracion()
        document.getElementById("initialConfigBreadcrumb").className = document.getElementById("initialConfigBreadcrumb").className.replaceAll(" hidden", "") + " hidden"
      }
      else{
        document.title = "HELIAS - Configuración inicial: Grupo electrógeno"
      }
    }
    
  }, []);
  
  const [appSensorFase1, setAppSensorFase1] = useState("")
  const [appSensorFase2, setAppSensorFase2] = useState("")
  const [appSensorFase3, setAppSensorFase3] = useState("")
  const [illustrationElements, setIllustrationElements] = useState([])

  function procesarConfiguracionActual(jsonRespuesta){

    if(jsonRespuesta.Generator.toString().length > 0){ 
            
      var configuracionPasoActual = jsonRespuesta.Generator

      if(configuracionPasoActual.GeneratorType === "TRIFASICO"){
        mostrarPestañaTipoGrupo("TRIFASICO")
      }
      else{
        mostrarPestañaTipoGrupo("MONOFASICO")
      }

      document.getElementById("potenciaMaximaGrupo").value = configuracionPasoActual.GeneratorMaxGeneration       
      document.getElementById("capacidadDepositoGrupo").value = configuracionPasoActual.GeneratorTankCapacity
      document.getElementById("consumoMaximoGrupo").value = configuracionPasoActual.GeneratorConsumption100percent.toString()              
      document.getElementById("selectTipoCombustible").value = configuracionPasoActual.CombustibleType.toString()          
      document.getElementById("precioCombustible").value = configuracionPasoActual.CombustiblePrice.toString()          
      
      if(configuracionPasoActual.GeneratorP1Sensor !== ""){
        var datosDispositivoFase1 = configuracionPasoActual.GeneratorP1Sensor.split("|")
        setAppSensorFase1(datosDispositivoFase1[0]) 
        document.getElementById("sensorFase1Span").innerHTML = datosDispositivoFase1[datosDispositivoFase1.length-1]
        document.getElementById("sensorFase1").value = datosDispositivoFase1[0]+"|"+datosDispositivoFase1[1]+"|"+datosDispositivoFase1[2]
        document.getElementById("sensorFase1FieldsetSinConfigurar").style="display: none"
        document.getElementById("sensorFase1FieldsetSeleccionado").style="display"
      }    
      
      if(configuracionPasoActual.GeneratorP2Sensor !== ""){
        var datosDispositivoFase2 = configuracionPasoActual.GeneratorP2Sensor.split("|")
        setAppSensorFase2(datosDispositivoFase2[0]) 
        document.getElementById("sensorFase2Span").innerHTML = datosDispositivoFase2[datosDispositivoFase2.length-1]
        document.getElementById("sensorFase2").value = datosDispositivoFase2[0]+"|"+datosDispositivoFase2[1]+"|"+datosDispositivoFase2[2]
        document.getElementById("sensorFase2FieldsetSinConfigurar").style="display: none"
        document.getElementById("sensorFase2FieldsetSeleccionado").style="display"
      }        

      if(configuracionPasoActual.GeneratorP3Sensor !== ""){
        var datosDispositivoFase3 = configuracionPasoActual.GeneratorP3Sensor.split("|")
        setAppSensorFase3(datosDispositivoFase3[0]) 
        document.getElementById("sensorFase3Span").innerHTML = datosDispositivoFase3[datosDispositivoFase3.length-1]
        document.getElementById("sensorFase3").value = datosDispositivoFase3[0]+"|"+datosDispositivoFase3[1]+"|"+datosDispositivoFase3[2]
        document.getElementById("sensorFase3FieldsetSinConfigurar").style="display: none"
        document.getElementById("sensorFase3FieldsetSeleccionado").style="display"
      }        
      
      document.getElementById("botonEliminarConfiguracion").className = document.getElementById("botonEliminarConfiguracion").className.replaceAll(" hidden", "")

    }              
    
    //Si no hay datos configurados entonces no hago nada  
    setIllustrationElements(initialConfigCommonJS.cargaInicialIlustracion(jsonRespuesta))
 
  }

  function cargarConfiguracionActualPaso(){

    var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
    var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")    
    var ongoingInstallationConfigurationID = localStorage.getItem("ongoingInstallationConfiguration")    
  
    //Petición de datos para el paso actual
    var jsonPeticion = {
      "accountID": localStorage.getItem("accountID"),
      "installationID": ongoingInstallationConfigurationID,    
      "GeneralInfo": "",
      "Meteo": "",
      "FV": "",
      "Battery": "",
      "Generator": "",
      "Cars": "",
      "Messaging": ""
    }
  
    // Guardo la información  
    var xhttp = new XMLHttpRequest();  
      xhttp.open("POST", getInstallationConfiguration, true);        
      xhttp.setRequestHeader('Content-Type', "application/json");
      xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
      var data = JSON.stringify(jsonPeticion);
      xhttp.onreadystatechange = function() {
        
        if (this.readyState === 4 && this.status === 200) {
          var jsonRespuesta = JSON.parse(this.responseText)
          if(jsonRespuesta.statusCode === "403"){                   
            initialConfigCommonJS.mostrarMensajeInformativo("No tiene permisos para realizar la operación.","negative")
          }
          else{          
            procesarConfiguracionActual(jsonRespuesta.body)     
            console.log("Información cargada correctamente")
          }
        }
  
        if (this.readyState === 4 && this.status !== 200) {                          
          initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)       
        }
      }
      xhttp.send(data);      
  }
  
  function mostrarPestañaTipoGrupo(pestaña){

    if(pestaña === "MONOFASICO"){      
      document.getElementById("MONOFASICO").checked = true    
      document.getElementById("divFases2y3").style = "display: none"      

      document.getElementById("textoBoton1Monitor").innerHTML = 'Seleccionar dispositivo'
    }
    else{
      document.getElementById("TRIFASICO").checked = true      
      document.getElementById("divFases2y3").style = "display"      

      document.getElementById("textoBoton1Monitor").innerHTML = 'Seleccionar dispositivo para la Fase 1'
    }
  
  }
  
  function validacionCamposCorrecta(){

    var numeroErroresValidacion = 0
    
    document.getElementById("potenciaMaximaGrupo").className = ""          
    document.getElementById("capacidadDepositoGrupo").className = ""      
    document.getElementById("consumoMaximoGrupo").className = ""      
    document.getElementById("precioCombustible").className = ""      
    
    document.getElementById("sensorFase1Link").className = "link"
    document.getElementById("sensorFase2Link").className = "link"
    document.getElementById("sensorFase3Link").className = "link"
    
    if(document.getElementById("potenciaMaximaGrupo").value === ""){
      numeroErroresValidacion++
      document.getElementById("potenciaMaximaGrupo").className = "error"
    }

    if(document.getElementById("capacidadDepositoGrupo").value === ""){
      numeroErroresValidacion++
      document.getElementById("capacidadDepositoGrupo").className = "error"
    }

    if(document.getElementById("consumoMaximoGrupo").value === ""){
      numeroErroresValidacion++
      document.getElementById("consumoMaximoGrupo").className = "error"
    }

    if(document.getElementById("MONOFASICO").checked === true){

      if(document.getElementById("sensorFase1").value === ""){
        numeroErroresValidacion++
        document.getElementById("sensorFase1Link").className += " error"
      }

    }
    else{

      if(document.getElementById("sensorFase1").value === ""){
        numeroErroresValidacion++
        document.getElementById("sensorFase1Link").className += " error"
      }

      if(document.getElementById("sensorFase2").value === ""){
        numeroErroresValidacion++
        document.getElementById("sensorFase2Link").className += " error"
      }

      if(document.getElementById("sensorFase3").value === ""){
        numeroErroresValidacion++
        document.getElementById("sensorFase3Link").className += " error"
      }

    }
   
    if(numeroErroresValidacion > 0){      
      document.getElementById("divErrorValidacionFormulario").className="message error left"
      return false
    }
    else{
      document.getElementById("divErrorValidacionFormulario").className="message error left hidden"
      return true
    }

  }

  function guardarInformacionPaso(direccion){
    
    var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
    var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")    
    var ongoingInstallationConfigurationID = localStorage.getItem("ongoingInstallationConfiguration")  
      
    //Preparo los datos necesarios para el json
  
    document.getElementById("loaderGenerator").className="loader overlay"
  
    var tipoGrupo
    if(document.getElementById("MONOFASICO").checked === true){
      tipoGrupo = "MONOFASICO"
    }
    else{
      tipoGrupo = "TRIFASICO"
    }

    var interruptorOnOff = ""
    
    var sensorFase1 = document.getElementById("sensorFase1").value+"|"+document.getElementById("sensorFase1Span").innerHTML    
    var sensorFase2 = ""
    var sensorFase3 = ""

    if(tipoGrupo === "TRIFASICO"){      
      sensorFase2 = document.getElementById("sensorFase2").value+"|"+document.getElementById("sensorFase2Span").innerHTML
      sensorFase3 = document.getElementById("sensorFase3").value+"|"+document.getElementById("sensorFase3Span").innerHTML      
    }    

    var jsonGenerator = {    
      "GeneratorType": tipoGrupo,
      "GeneratorMaxGeneration": document.getElementById("potenciaMaximaGrupo").value.replaceAll(",","."),
      "GeneratorTankCapacity": document.getElementById("capacidadDepositoGrupo").value.replaceAll(",","."),
      "GeneratorConsumption100percent": document.getElementById("consumoMaximoGrupo").value.replaceAll(",","."),
      "CombustiblePrice": document.getElementById("precioCombustible").value.replaceAll(",","."),
      "CombustibleType": document.getElementById("selectTipoCombustible").value,
      "GeneratorOnOffSwitch": interruptorOnOff,
      "GeneratorP1Sensor": sensorFase1,
      "GeneratorP2Sensor": sensorFase2,
      "GeneratorP3Sensor": sensorFase3
    }

    var jsonGuardado = {
      "accountID": localStorage.getItem("accountID"),
      "installationID": ongoingInstallationConfigurationID,
      "Generator": jsonGenerator
    }
  
    // Guardo la información  
    var xhttp = new XMLHttpRequest();  
      xhttp.open("POST", updateInstallationConfiguration, true);        
      xhttp.setRequestHeader('Content-Type', "application/json");
      xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
      var data = JSON.stringify(jsonGuardado);
      xhttp.onreadystatechange = function() {
        
        if (this.readyState === 4 && this.status === 200) {
          var jsonRespuestaGuardado = JSON.parse(this.responseText)

          if(jsonRespuestaGuardado.statusCode === "403"){                   
            initialConfigCommonJS.mostrarMensajeInformativo("No tiene permisos para realizar la operación.","negative")
          }
          else{          
            console.log("Información guardada correctamente")          

            if(localStorage.getItem("installationConfigurationMode") === null){
              if(localStorage.getItem("ongoingStepConfiguration") === "GENERATOR" ){      
                initialConfigCommonJS.navegarDinamico(direccion)
              }
              else{
                initialConfigCommonJS.mostrarMensajeInformativo('Todavía no he cargado la información para continuar, me has pillado despistao, inténtalo de nuevo ahora a ver...',"")
              }
            }
            else{
              initialConfigCommonJS.mostrarMensajeInformativo("Configuración guardada correctamente, estoy conectándome a los sistemas configurados así que puede que los cambios tarden un par de minutos en reflejarse.","positive")
              document.getElementById("asideDetalleConfiguracion").className += " hidden"
              document.getElementById("loaderGenerator").className="loader hidden"
            }
          }
        }
  
        if (this.readyState === 4 && this.status !== 200) {                          
          initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)       
        }
      }
      xhttp.send(data);    
      
  }
  
  function navegar(direccion){      
    if(initialConfigCommonJS.existeSesion()){
      if(direccion === "continuar"){
        if(validacionCamposCorrecta()){    
          if(document.getElementById("contenedorPrincipalOpcion") !== null){
            document.getElementById("contenedorPrincipalOpcion").scrollTop = 0
          }
          guardarInformacionPaso(direccion)
        }
      }
      else{
        if(localStorage.getItem("ongoingStepConfiguration") === "GENERATOR"){      
          initialConfigCommonJS.navegarDinamico(direccion)
        }
        else{
          initialConfigCommonJS.mostrarMensajeInformativo('Todavía no he cargado la información para continuar, me has pillado despistao, inténtalo de nuevo ahora a ver...',"")
        }
      }
    }
  }

  return (          
    <main id="divMainContenedorStep">      

      <InitialConfigHeader step={"GENERATOR"}/>

      <section id="generator" className="step wrapper">
        <div id="divContenedorStep" className="content-wrapper half">

          <StepIntro 
            Title="Grupo electrógeno" 
            Intro=  {<p>Para exprimir al máximo su rendimiento, necesito que me orientes un poco con unos datos básicos para usar de referencia.</p>}
          />  
          <fieldset>
            <fieldset>

              <fieldset className="two-columns tooltip-parent">
                <fieldset>
                  <label className="has-tooltip" htmlFor="labelPotenciaMaximaGrupo">  
                    <span className="label tooltip-label">Potencia máxima del grupo</span>                
                    <span className="tooltip-trigger">
                      <span className="material-icon tooltip-icon link size-s">info</span>
                      <span className="tooltip bottom">
                        <span className="tooltip-container">
                          <p className="size-m tooltip-title">¿Qué potencia máxima tiene tu generador?</p>
                          <p className="size-s">Suele venir <strong>indicado en una pequeña placa plateada pegada en el propio aparato y viene especificado en kW o kVA</strong>. Sino puedes preguntárselo a tu vendedor o consultarlo en el manual del aparato.</p>                        
                        </span>
                      </span>
                    </span>
                  </label>
                  
                  <fieldset className="icon-wrapper data" data-label="KVA / KW">
                    <input type="text" inputMode="decimal" id="potenciaMaximaGrupo"/>
                  </fieldset>
                </fieldset>

                <fieldset>
                  <label htmlFor="labelCapacidadDepositoGrupo">Capacidad depósito de combustible</label>
                  <fieldset className="icon-wrapper data" data-label="Litros">
                    <input type="text" inputMode="decimal" id="capacidadDepositoGrupo"/>
                  </fieldset>
                </fieldset>
              </fieldset>

              <fieldset className="two-columns tooltip-parent">
                
                <fieldset>
                  <legend>Tipo de combustible</legend>
                  <fieldset className="dropdown">                
                    <div className="icon-wrapper">
                      <select id="selectTipoCombustible">
                        <option value="DIESEL">Diésel</option>
                        <option value="DIESELPLUS">Diésel Plus</option>                       
                        <option value="GASB">Gasóleo B</option>
                        <option value="GAS98">Gasolina 98</option>
                        <option value="GAS95">Gasolina 95</option>
                        <option value="BIODIESEL">Biodiésel</option>                        
                        <option value="GNL">Gas Natural Licuado</option>
                        <option value="GNC">Gas Natural Comprimido</option>
                        <option value="GLP">Gas Licuado del Petróleo</option>
                      </select>
                    </div>
                  </fieldset>     
                </fieldset>

                <fieldset>
                  <label className="has-tooltip" htmlFor="labelPrecioCombustible">
                    <span className="label tooltip-label">Precio del combustible</span>
                    <span className="tooltip-trigger">
                    <span className="material-icon tooltip-icon link size-s">info</span>
                      <span className="tooltip bottom">
                        <span className="tooltip-container">
                          <p className="size-m tooltip-title">¿Precio del combustible?</p>
                          <p className="size-s">Puedes dejarlo en blanco si no lo sabes y aplicaremos el precio medio nacional. Aunque si quieres exactitud te animo a que introduzcas el precio real.</p>                                
                        </span>
                      </span>
                    </span>
                  </label>                  
                  <fieldset className="icon-wrapper data" data-label="EUR por Litro">
                    <input type="text" inputMode="decimal" id="precioCombustible"/>
                  </fieldset>
                </fieldset>

              </fieldset>
            </fieldset>

            <fieldset>     
                  <label className="has-tooltip" htmlFor="labelConsumoMaximoGrupo">  
                    <span className="label tooltip-label">Consumo máximo de combustible</span>                
                    <span className="tooltip-trigger">
                      <span className="material-icon tooltip-icon link size-s">info</span>
                      <span className="tooltip bottom">
                        <span className="tooltip-container">
                          <p className="size-m tooltip-title">¿Cual es el consumo máximo de mi generador?</p>
                          <p className="size-s">Suele venir indicado en el <strong>manual del aparato</strong>, aun así si no dispones de él te recomiendo que indiques un consumo aproximado en base al uso que le has dado hasta ahora y que vayas ajustando este valor en el apartado de configuración hasta que encaje con el consumo real.</p>
                        </span>
                      </span>
                    </span>
                  </label>

                  <fieldset className="icon-wrapper data" data-label="Litros por hora">
                    <input type="text" inputMode="decimal" id="consumoMaximoGrupo"/>
                  </fieldset>
                </fieldset>

            <fieldset>
              <fieldset className="radio multiple">
                <legend>¿De qué tipo es?</legend>
                <div className="tabs">
                  <input type="radio" id="MONOFASICO" name="labelSelectTipoGrupo" defaultChecked="true"/>
                  <label htmlFor="MONOFASICO" onClick={() => mostrarPestañaTipoGrupo("MONOFASICO")}>
                    <span className="label">Monofásico</span>
                  </label>

                  <input type="radio" id="TRIFASICO" name="labelSelectTipoGrupo" />
                  <label htmlFor="TRIFASICO" onClick={() => mostrarPestañaTipoGrupo("TRIFASICO")}>
                    <span className="label">Trifásico</span>
                  </label>
                </div>
              </fieldset>

              <div className="tab-content" htmlFor="labelSelectTipoGrupo">

                <fieldset>
                    <fieldset>                    
                      <label className="has-tooltip" htmlFor="labelSensorFases">  
                      <span className="label tooltip-label">Monitor del grupo electrógeno</span>                        
                      <span className="tooltip-trigger">                        
                        <span className="material-icon tooltip-icon link size-s">info</span>
                        <span className="tooltip bottom">
                          <span className="tooltip-container">
                            <p className="size-m tooltip-title">¿Monitor de medición del grupo?</p>
                            <p className="size-s">Tu grupo electrógeno puede ser monofásico (1 fase) o trifásico (3 fases). Para poder ayudarte a controlar eficientemente tu instalación necesitamos poder leer la actividad eléctrica de cada una de ellas. Normalmente los grupos no vienen con estos sensores, así que hay que instalárselos aparte. A continuación te dejo unos enlaces donde encontrar sensores para grupos monofásicos y trifásicos.</p>
                            <a href="https://www.shellyespana.com/shelly-em/" target="_blank" className="link size-s"  rel="noopener noreferrer"><span className="material-icon">article</span>Sensor monofásico</a>
                            <a href="https://shellyspain.com/rele-shelly-3-em.html" target="_blank" className="link size-s"  rel="noopener noreferrer"><span className="material-icon">article</span>Sensor trifásico</a>
                          </span>
                        </span>
                      </span>
                      </label>           
                    </fieldset>

                    <fieldset>
                      
                      <fieldset id="sensorFase1FieldsetSinConfigurar">                  
                        <p id="textoIntroMonitorGrupo">Aquí debes configurar el dispositivo con el que midas la generación de tu grupo electrógeno.</p>              
                        <button id="sensorFase1Link" className="link" onClick={() => initialConfigCommonJS.configurarDispositivo("sensorFase1")}><span className="material-icon">add_circle</span><span id="textoBoton1Monitor"></span></button>
                      </fieldset>

                      <fieldset id="sensorFase1FieldsetSeleccionado" style={{display: "none"}}>
                        <legend>Sensor medición fase 1</legend>
                        <div className="selector icon-wrapper no-icon">
                          <div className="horizontal vertical-center gap-04 fill" onClick={() => initialConfigCommonJS.configurarDispositivo("sensorFase1")}>
                            <figure className="avatar size-m"><AppLogoImg id="sensorFase1LogoApp" aplicacion={appSensorFase1}/></figure>
                            <span id="sensorFase1Span" className="label"></span>
                          </div>
                          <input type="text" id="sensorFase1" style={{display: "none"}}/>
                        </div>
                      </fieldset>

                      <fieldset id="divFases2y3">
                        <fieldset id="sensorFase2FieldsetSinConfigurar">                  
                          <button id="sensorFase2Link" className="link" onClick={() => initialConfigCommonJS.configurarDispositivo("sensorFase2")}><span className="material-icon">add_circle</span>Seleccionar dispositivo para la Fase 2</button>
                        </fieldset>

                        <fieldset id="sensorFase2FieldsetSeleccionado" style={{display: "none"}}>
                          <legend>Sensor medición fase 2</legend>
                          <div className="selector icon-wrapper no-icon" >
                            <div className="horizontal vertical-center gap-04 fill" onClick={() => initialConfigCommonJS.configurarDispositivo("sensorFase2")}>
                              <figure className="avatar size-m"><AppLogoImg id="sensorFase2LogoApp" aplicacion={appSensorFase2}/></figure>
                              <span id="sensorFase2Span" className="label"></span>
                            </div>
                            <input type="text" id="sensorFase2" style={{display: "none"}}/>
                          </div>
                        </fieldset>

                        <fieldset id="sensorFase3FieldsetSinConfigurar">                  
                          <button id="sensorFase3Link" className="link" onClick={() => initialConfigCommonJS.configurarDispositivo("sensorFase3")}><span className="material-icon">add_circle</span>Seleccionar dispositivo para la Fase 3</button>
                        </fieldset>

                        <fieldset id="sensorFase3FieldsetSeleccionado" style={{display: "none"}}>
                          <legend>Sensor medición fase 3</legend>
                          <div className="selector icon-wrapper no-icon">
                            <div className="horizontal vertical-center gap-04 fill" onClick={() => initialConfigCommonJS.configurarDispositivo("sensorFase3")}>
                              <figure className="avatar size-m"><AppLogoImg id="sensorFase3LogoApp" aplicacion={appSensorFase3}/></figure>
                              <span id="sensorFase3Span" className="label"></span>
                            </div>
                            <input type="text" id="sensorFase3" style={{display: "none"}}/>
                          </div>
                        </fieldset>
                      </fieldset>

                    </fieldset>
                </fieldset>
              </div>

            </fieldset>
          </fieldset>
          <FormValidationError/>

          <WorkflowNavigationButtons step={"GENERATOR"} navegar={navegar}/>

        </div>

        { localStorage.getItem("installationConfigurationMode") === null
          ? <WorkflowIlustration illustrationElements={illustrationElements}/>
          : <></>
        }

        <Loader Id="loaderGenerator" Mensaje=""/>

      </section>

      <AsideMenu selectedLocation={selectedLocation} setSelectedLocation={setSelectedLocation}/>

    </main>
    
  )
}

export default Generator